'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _number_utility = require('../../../../packages/common-utilities/src/number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormattedNumber = function (_PureComponent) {
  _inherits(FormattedNumber, _PureComponent);

  function FormattedNumber() {
    _classCallCheck(this, FormattedNumber);

    return _possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).apply(this, arguments));
  }

  _createClass(FormattedNumber, [{
    key: 'formatEuropeanNumber',
    value: function formatEuropeanNumber(value) {
      if (typeof value !== "string") {
        return value;
      }

      return (0, _ramda.map)(function (char) {
        if (char === ".") {
          return ",";
        } else if (char === ",") {
          return ".";
        }

        return char;
      }, value).join("");
    }
  }, {
    key: 'formattedNumber',
    value: function formattedNumber() {
      return this.numberFormatter(this.props.value, this.props.numberFormat, this.props.preventScientificNotation);
    }
  }, {
    key: 'numberFormatter',
    value: function numberFormatter(value, numberFormat, preventScientificNotation) {
      var formattedNumber = void 0;
      if (numberFormat === "european") {
        formattedNumber = this.formatEuropeanNumber(value);
      } else if (numberFormat === "canadian") {
        formattedNumber = _number_utility2.default.convertToEuropeanFormat(value, numberFormat);
      } else if (preventScientificNotation) {
        formattedNumber = Number(value).toFixed(12).replace(/\.?0+$/, "");
      } else {
        formattedNumber = value;
      }
      return formattedNumber;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.formattedNumber()
      );
    }
  }]);

  return FormattedNumber;
}(_react.PureComponent);

exports.default = FormattedNumber;


FormattedNumber.propTypes = {
  value: _propTypes2.default.any.isRequired
};